import { safeDefineFsComponent } from '@cof/safe-custom-element-define';
import { FsRadio as Radio } from './src/index.js';
const { customElementClass, safeTagName } = safeDefineFsComponent.define(Radio);
/** Export the custom element class and it's related type */
export const FsRadio = customElementClass;
/** Export the canonical name for use in certain build tools */
export const tagName = safeTagName;
//# sourceMappingURL=fs-radio.js.map